import InfiniteList from 'components/InfiniteList'
import { useModalContext } from 'context/EventModalContext'
import React, { useCallback, useMemo, useState } from 'react'
import { useEventAttendees } from 'hooks/events'
import EventAttendeeListItem, {
  IEventContext
} from 'components/events/Video/AttendeeListItem'
import { useEventVideoContext } from 'context/EventVideoContext'
import { EventQueryResult } from 'graphql/generated'
import { faSearch } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import BaseModal from './BaseModal'

export function useEventAttendeesModal() {
  const { setModalContent } = useModalContext()

  return useCallback(() => {
    setModalContent(<EventAttendeesModal />)
  }, [setModalContent])
}

export const EventAttendees: React.FC<{
  event: EventQueryResult['event']
  eventContext: IEventContext
}> = ({ event, eventContext }) => {
  const { edges, loadMore, loadingMore, loading } = useEventAttendees(
    event.id,
    500
  )

  const [nameQuery, setNameQuery] = useState<string | undefined>(undefined)

  const edgesFiltered = useMemo(() => {
    let edgesFiltered = edges

    if (nameQuery && nameQuery.length > 0) {
      edgesFiltered = edges?.filter(edge =>
        edge.node.user.displayName
          ?.toLowerCase()
          .includes(nameQuery.toLowerCase())
      )
    }
    return edgesFiltered
  }, [edges, nameQuery])

  return (
    <div className="min-h-[400px] h-full flex flex-col overflow-hidden m-2">
      <div className="m-4 overflow-hidden flex-1 flex flex-col">
        <h3
          className="text-lg leading-6 font-medium text-gray-900 mb-2"
          id="modal-headline"
        >
          {`${event.title} \u00b7 Attendees`}
        </h3>

        <div className="text-gray-600 bg-gray-100 hover:bg-gray-200 border-gray-300 px-2.5 py-1.5 rounded flex flex-row items-center transition-width w-64 mb-3">
          <FontAwesomeIcon icon={faSearch} />
          <input
            type="text"
            className={
              'block bg-transparent border-none focus:ring-0 focus:outline-none m-0 p-0 pl-2  w-full'
            }
            placeholder={'Search'}
            value={nameQuery}
            onChange={event => setNameQuery(event.currentTarget.value)}
          />
        </div>

        <div className="flex-1 overflow-auto">
          <InfiniteList
            className="space-y-1"
            items={edgesFiltered}
            loadMore={loadMore}
            loading={loading}
            loadingMore={loadingMore}
            renderItem={edge => (
              <EventAttendeeListItem
                key={`attendee-${edge.node.id}`}
                attendee={edge.node}
                eventContext={eventContext}
              />
            )}
          />
        </div>
      </div>
    </div>
  )
}

export const EventAttendeesModal: React.FC = () => {
  const { event } = useEventVideoContext()

  const { hideModal } = useModalContext()

  return (
    <BaseModal onClose={hideModal}>
      <EventAttendees event={event} eventContext="eventVideo" />
    </BaseModal>
  )
}
